import {Editor, mergeAttributes} from "@tiptap/core";
import floatAsStyle from "./utils/floatAsStyle";

export class ImgNodeView {


    private _dom: HTMLElement;
    private _domContent: HTMLImageElement;
    private _editor: Editor;
    private _attrs: Record<string, any>;
    private _getPos: any;
    private editorWidth: number;

    constructor(editor: Editor, attrs: Record<string, any>, getPos: any) {
        this._editor = editor;
        this._attrs = attrs;
        this._getPos = getPos;

        this._dom = document.createElement('span');

        let style: string[] = ['max-width: 100%'];
        style.push('width:' + this._attrs['data-width']);
        style.push(floatAsStyle(attrs['data-float'], 'none'));

        this._dom.setAttribute('style', style.join(';'));

        this._dom.classList.add("img-resize-wrapper");
        this._dom.classList.add("float-" + attrs['data-float']);
        this.editorWidth = editor.view.dom.getBoundingClientRect().width;

        if(this._attrs['data-width'] !== 'auto'){
            this._dom.classList.add("fill-img-width");
        }

        this.createImg();
        this.createButtons();
    }

    deselectNode(): void {
        this._dom.classList.remove("SelectedNode")
    }

    selectNode(): void {
        this._dom.classList.add("SelectedNode")
    }

    private createImg(){
        this._domContent = document.createElement('img');
        this._domContent.src = this._attrs.src;

        let style: string[] = ['max-width: 100%'];
        style.push(floatAsStyle(this._attrs['data-float'], 'none'));

        this._domContent.setAttribute('style', style.join(';'));

        this._dom.append(this._domContent);
    }

    private createButtons(){

        let widths = [
            '25%', '50%', '75%', '100%', 'auto'
        ]

        let toolbar = document.createElement('div');
        toolbar.classList.add('img-resize-wrapper--toolbar');

        for (const width of widths) {

            let btn = document.createElement('button');

            if(width !== 'auto'){
                btn.innerHTML = width;
            }else{
                btn.innerHTML = 'Oryginalny';
            }

            const view = this._editor.view;
            btn.addEventListener('click', (e) => {

                if(typeof this._getPos === 'function') {
                    this._editor.view.dispatch(
                        view.state.tr.setNodeMarkup(this._getPos(), undefined, {
                            float: this._attrs['data-float'],
                            src: this._attrs.src,
                            width: width
                        })
                    );

                    console.log("DISPATCH!!!!");

                    this._editor.commands.focus();
                }

            });

            toolbar.append(btn);
        }

        this._dom.append(toolbar);
    }


    get dom(): any {
        return this._dom;
    }

    get domContent(): HTMLImageElement {
        return this._domContent;
    }

}
